import { render } from "./Clientes.vue?vue&type=template&id=71cfae89&scoped=true&ts=true"
import script from "./Clientes.vue?vue&type=script&lang=ts"
export * from "./Clientes.vue?vue&type=script&lang=ts"

import "./Clientes.vue?vue&type=style&index=0&id=71cfae89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cfae89"]])

export default __exports__